export const getRandomCharacters = (allChars, numberToReturn) => {
  let generatedChars = new Set();

  while (generatedChars.size < numberToReturn) {
    const randomIndex = Math.floor(Math.random() * allChars.length);
    generatedChars.add(allChars.charAt(randomIndex));
  }

  return Array.from(generatedChars).join(' ');
};

export const getLogmarLineSize500mm = (size) => {
  if (!size) {
    return 0;
  }
  const requiredLetterSizeInMM = {};

  requiredLetterSizeInMM[1] = 7.37;
  requiredLetterSizeInMM[2] = 5.85;
  requiredLetterSizeInMM[3] = 4.64;
  requiredLetterSizeInMM[4] = 3.68;
  requiredLetterSizeInMM[5] = 2.92;
  requiredLetterSizeInMM[6] = 2.32;
  requiredLetterSizeInMM[7] = 1.84;
  requiredLetterSizeInMM[8] = 1.46;
  requiredLetterSizeInMM[9] = 1.16;
  requiredLetterSizeInMM[10] = 0.92;
  requiredLetterSizeInMM[11] = 0.74;
  requiredLetterSizeInMM[12] = 0.59;
  requiredLetterSizeInMM[13] = 0.47;

  return requiredLetterSizeInMM[size];
};

export const getLogmarScore = (size, seenCharacters) => {
  if (!size) {
    return 0;
  }

  if (seenCharacters === undefined) {
    seenCharacters = 5;
  }

  const logmarCharacterPenalty = 0.02;
  const logmarIntervalScore = 0.1;
  let logmarScore = 1.0;
  logmarScore = logmarScore - (size - 1) * logmarIntervalScore;
  if (seenCharacters < 5) {
    const unseenCharacters = 5 - seenCharacters;
    logmarScore = logmarScore + unseenCharacters * logmarCharacterPenalty;
  }

  return logmarScore;
};

export const calculateLogmarScore = (currentLogmarScore, penaltyMap) => {
  let finalScore = currentLogmarScore;
  for (const logmarId in penaltyMap) {
    finalScore = finalScore + penaltyMap[logmarId];
  }
  return finalScore;
};

export const getLogmarPenalty = (seenCharacters) => {
  if (seenCharacters === undefined) {
    seenCharacters = 5;
  }

  const logmarCharacterPenalty = 0.02;

  const currentPenalty = (5 - seenCharacters) * logmarCharacterPenalty;

  return currentPenalty;
};

export const getRandomEScore = (size) => {
  if (!size) {
    return 1.0;
  }

  const intervalScorePenalty = 0.1;
  let randomEScore = 1.0;
  randomEScore = randomEScore - (size - 1) * intervalScorePenalty;

  return randomEScore;
};

export const todayString = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  const hh = today.getHours();
  const ii = today.getMinutes();
  const ss = today.getSeconds();

  const today_string = dd + '/' + mm + '/' + yyyy + ' ' + hh + ':' + ii + ':' + ss;
  return today_string;
};

export const confirmNavigation = (localRestart) => {
  const confirmationMsg = localRestart
    ? 'Are you sure you want to restart this test? All results presented here will be lost.'
    : 'Navigating away from this page may mean that you lose test data. \n\n Please confirm you wish to leave the page by clicking "OK", or use "Cancel" to stay on the page.';

  return new Promise((resolve) => {
    if (window.confirm(confirmationMsg)) {
      return resolve();
    }
  });
};
